import * as queryString from "querystring";

/**
 * Get a param value from query string
 * @param {string} paramName - Query string param name
 * @param {Object} routerLocation - location props from useLocation() HOC (from react-router)
 */
export const getQueryStringParam = (paramName, routerLocation) => {
  const queryParams = queryString.parse(routerLocation.search.substring(1)); // substring(1) to remove "?" from the beginning
  return queryParams[paramName];
};

/**
 * Updates query string with new params
 * @param {Object} params - object with new query string values
 * @param {Object} routerLocation - location props from useLocation() HOC (from react-router)
 * @param {Object} routerHistory - history props from useHistory() HOC (from react-router)
 */
export const setQueryStringParams = (params, routerLocation, routerHistory) => {
  const queryParams = queryString.parse(routerLocation.search.substring(1)); // substring(1) to remove "?" from the beginning

  let isChanged = false;

  for (var key in params) {
    if (queryParams[key] !== params[key]) {
      isChanged = true;
    }
    queryParams[key] = params[key];
    if (params[key] === null) {
      delete queryParams[key];
    }
  }

  if (isChanged) {
    routerHistory.push({
      search: `?${queryString.stringify(queryParams)}`
    });
  }
};
